import React from "react";
import Skypiercer from "./img/skypiercer.png";
import ClickSafari from "./img/click-safari.png";
import Continental from "./img/Continental.png";
import Google from "./img/google.png";
import Petstop from "./img/Petstop.png";
import ZamsRecipes from "./img/ZamsRecipes.png";


function Main(){
    return(
        <div className="main-body">
            <div className="body-portfolio">
                <h1>Portfolio</h1>
                <div className="box-row">
                    <div className="box">
                        <a href="https://nseraj11.github.io/Skypiercer/">
                            <img src={Skypiercer} style={{height:200, width:400}} alt="Skypiercer" />
                        </a>  
                    </div>
                    <div className="box">
                        <a href="https://nseraj11.github.io/PetStop/">
                            <img src={Petstop} style={{height:200, width:400}} alt="Continental" />
                        </a>
                    </div>
                </div>
                <div className="box-row">
                    <div className="box">
                        <a href="https://nseraj11.github.io/TheContinental/">
                            <img src={Continental} style={{height:200, width:400}} alt="Continental" />
                        </a>                    
                    </div>
                    <div className="box">
                        <a href="https://nseraj11.github.io/ZamsRecipes/">
                            <img src={ZamsRecipes} style={{height:200, width:400}} alt="Continental" />
                        </a>
                    </div>
                </div>
                <div className="box-row">
                    <div className="box">
                        <a href="https://nseraj11.github.io/ClickSafari/">
                            <img src={ClickSafari} style={{height:200, width:400}} alt="CS" />
                        </a>
                    </div>
                    <div className="box">
                        <a href="https://nseraj11.github.io/GoogleClone1/">
                            <img src={Google} style={{height:200, width:400}} alt="Continental" />
                        </a>
                    </div>
                </div>
            </div>
            <div className="body-skills-tech">
                <div className="body-skills">
                    <h1>Experience</h1>
                        <ul>
                            <li>Designer and creator of fully functioning sites</li>
                            <li>Using CSS and Bootstrap to fully design sites to desired outline</li>
                            <li>Using specialized CSS to give sites the ability to perform on any sized device</li>
                            <li>Implemented JavaScript to create dynamic web pages</li>
                            <li>Created a fully functioning web application using a combination of front end and back end tools that can perform CRUD operations</li>
                            <li>Created simple game using basic JavaScript</li>
                            <li>Created custom API</li>
                            <li>Used Mongoose to create interactable routes with custom API</li>
                            <li>Created Test Scenarios and Test Cases to ensure full functionality of each site</li>
                            <li>Used web frameworks such as Selenium WebDriver to perform cross browsing testing</li>
                            <li>Used automation frameworks such as TestNG to perform end to end testing for sites</li>
                            <li>Used Cucumber to create testing frameworks that are easier to read than more traditional testing tools</li>
                        </ul>
                </div>
                <div className="body-tech">
                    <h1>Technical Expertise</h1>
                    <ul>
                        <li>Front End: <span>HTML, CSS, JavaScript, Bootstrap, Express, React</span></li>
                        <li>Back End: <span>Node.js, Rest API, MongoDB, Mongoose, Studio 3T, Postman</span></li>
                        <li>IDE: <span>Visual Studio Code</span></li>
                        <li>OS: <span>Mac OS</span></li>
                        <li>Database: <span>MySQL, NoSQL</span></li>
                    </ul>
                </div> 
            </div>
        </div>
    )
}

export default Main;